import { useMutation } from '@fv/client-core'
import type { SaveQuoteDTO } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

const postSaveQuote = (loadId: string) => async (body: SaveQuoteDTO) =>
  shipperFetch<void>(`/shipments/${loadId}/quotes/save`, {
    body,
    method: 'POST',
  })

export function useSaveQuote(loadId: string) {
  return useMutation(postSaveQuote(loadId))
}
